import ContentModal from './ContentModal'

export default ContentModal
